import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import '../Adminassets/TagInput.css';
import '../Adminassets/Style.css';
import { useNavigate } from 'react-router-dom';
import Spinner from '../component/Spinner';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormControl, InputLabel, Checkbox, ListItemText } from '@mui/material';
import api from '../data/api';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import { useAtomValue } from 'jotai';
import CalendarInput from '../component/CalendarInput';
import toast from 'react-hot-toast';
import { getTrailerData } from '../api/classVideoApi';
import videoApi from '../api/videoApi';
import { useReducer } from 'react';
import {
	formReducer,
	initialState,
	setField,
	addTag,
	removeTag,
	addProduct,
	removeProduct,
	addKeyword,
	removeKeyword,
	setVideoLevel,
	setDate,
	resetForm,
	setVideoData,
	setTrailerData
} from '../redux/formData';
import dayjs from 'dayjs';
import { useFetchInstructors } from '../data/swrs/instructor';
import { newYorkMidnight } from '@/utils/helper';
import ReleaseSchedule from '@/AdminComponent/components/ReleaseSchedule';

const AddClassVideos = () => {
	axios.defaults.withCredentials = true;
	const [formData, dispatch] = useReducer(formReducer, initialState);
	const [productQuery, setProductQuery] = useState('');
	const userData = useAtomValue(userInfoAtom);
	const redirect = useNavigate();
	const [query, setQuery] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [backendTags, setBackendTags] = useState([]);
	const [backendProducts, setBackendProducts] = useState([]);
	const [trailerId, setTrailerId] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showTagsUI, setShowTagsUI] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [fetchIsLoading, setFetchIsLoading] = useState(false);
	const [fetchTrailerLoading, setFetchTrailerLoading] = useState(false);

	const [errorMessage, setErrorMessage] = useState('');
	const [presentInstrutors, setPresentInstructors] = useState([]);
	const [isAddingNewInstructor, setIsAddingNewInstructor] = useState(false);
	const [keywordQuery, setKeywordQuery] = useState('');
	const { instructors, isError } = useFetchInstructors(userData?.token);

	useEffect(() => {
		if (isError) {
			toast.error('Something went wrong while fetching instructors');
			console.error('Error fetching instructors:', isError);
		}
	}, [isError]);

	useEffect(() => {
		setPresentInstructors(instructors);
	}, [instructors]);

	useEffect(() => {
		const performSearch = async querySpecial => {
			try {
				const response = await api.searchTags(querySpecial);
				const newBackendTags = [];

				response.data?.map(tag => {
					let flag = true;
					// eslint-disable-next-line array-callback-return
					formData?.tags.map(tag1 => {
						if (tag1 === tag.name) {
							flag = false;
						}
					});
					if (flag) {
						newBackendTags.push(tag);
					}
				});
				setBackendTags(newBackendTags);
			} catch (error) {
				console.error('Error fetching tags:', error);
			}
		};

		if (query.trim()) {
			const querySpecial = query.trim();
			performSearch(querySpecial);
		} else {
			setBackendTags([]);
		}
	}, [query]);

	useEffect(() => {
		const performSearch = async querySpecial => {
			try {
				const response = await api.searchProducts(querySpecial);
				setBackendProducts(response.data);
			} catch (error) {
				console.error(error);
			}
		};

		if (productQuery.trim()) {
			const querySpecial = productQuery.trim();
			performSearch(querySpecial);
		} else {
			setBackendProducts([]);
		}
	}, [productQuery]);

	const handleChange = e => {
		dispatch(setField(e.target.name, e.target.value));
	};

	const handleDateChange = date => {
		dispatch(setDate(date));
	};

	const showLoader = () => {
		setIsLoading(true);
	};

	const hideLoader = () => {
		setIsLoading(false);
	};

	const handleTagRemove = tag => {
		dispatch(removeTag(tag));
	};
	const handleProductRemove = product => {
		dispatch(removeProduct(product));
	};
	const handleTagAdd = newTag => {
		if (newTag?.trim().length > 0 && !formData?.tags.includes(newTag)) {
			dispatch(addTag(newTag));
		}
	};

	const handleProductAdd = newProduct => {
		if (newProduct.trim().length > 0 && !formData.products.includes(newProduct)) {
			dispatch(addProduct(newProduct));
			setProductQuery(''); // Reset input after adding
		}
	};
	const handleKeyWordAdd = newKeyword => {
		if (
			newKeyword?.trim().length > 0 &&
			!formData?.keywords.some(k => k.name === newKeyword) // Proper duplicate check
		) {
			dispatch(addKeyword({ name: newKeyword })); // Ensure correct object structure
		}
	};

	const handleKeywordRemove = keyword => {
		dispatch(removeKeyword(keyword));
	};

	const fetchVideoData = async e => {
		e.preventDefault();
		try {
			setFetchIsLoading(true);
			const response = await videoApi.getVideoData(formData.videoId);

			if (response.status === 200) {
				const videoData = response.data.videoData;
				dispatch(setVideoData(videoData));
				setFetchIsLoading(false);
			} else if (response.status === 201 || response.status === 401) {
				console.log('error:', response);
				toast.error('Please Login Again');
				redirect('/login');
			}
		} catch (error) {
			setFetchIsLoading(false);
			toast.error('Somethng went wrong');
			console.error('Error fetching video data:', error);
		}
	};
	const fetchTrailerData = async e => {
		e.preventDefault();
		try {
			setFetchTrailerLoading(true);
			const response = await getTrailerData(trailerId);

			const trailerData = response.trailerData;
			dispatch(setTrailerData(trailerData));
			setFetchTrailerLoading(false);
		} catch (error) {
			setFetchTrailerLoading(false);
			toast.error(error);
			console.error('Error fetching video data:', error);
		}
	};

	const handleSubmit = async e => {
		e.preventDefault();
		showLoader();
		const classFormData = { ...formData, type: 'class' };

		const dateOnly = formData.releaseDate ? dayjs(formData.releaseDate).format('YYYY-MM-DD') : null;
		classFormData.releaseDate = dateOnly;
		classFormData.dateOnly = dateOnly;

		try {
			//setLoading(true);
			const response = await videoApi.addVideo(classFormData);

			if (response.status === 200) {
				toast.success('Success! Data submitted successfully!', { position: 'top-center', duration: 3000 });
				setShowTagsUI(false);
				hideLoader();
				dispatch(resetForm());
				setTrailerData('');
				setQuery('');
				redirect('/AdminDashboard/AllVideos');
			} else if (response.status === 201 || response.status === 401) {
				toast.error('Please Login Again', {
					position: 'top-center',
					duration: 3000
				});
				redirect('/login');
			} else {
				toast.error('Danger! Error submitting data. Please try again.', {
					position: 'top-center',
					duration: 3000
				});
			}
		} catch (error) {
			console.error('Error saving data:', error);
		} finally {
			setTimeout(() => {
				setSuccessMessage('');
				setErrorMessage('');
			}, 20000);
		}
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			setSuccessMessage('');
			setErrorMessage('');
		}, 20000);

		return () => clearTimeout(timer); // Clear the timer when the component unmounts or when successMessage/ errorMessage changes
	}, [successMessage, errorMessage]);

	const handleVideoLevelChange = event => {
		const { value } = event.target;
		dispatch(setVideoLevel(value)); // Directly updating array of selected values
	};
	return (
		<div>
			{isLoading && <Spinner />}

			{successMessage && <div className="alert-success">{successMessage}</div>}

			{errorMessage && <div className="alert-danger">{errorMessage}</div>}

			{!isLoading && (
				<Card className="p-3">
					<CardContent>
						<Form>
							<Form.Group controlId="videoId">
								<Form.Label>Video ID</Form.Label>
								<Form.Control
									type="text"
									name="videoId"
									placeholder="Enter video ID"
									value={formData.videoId}
									onChange={e => {
										handleChange(e);
									}}
								/>
							</Form.Group>
							<div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
								<Button className="mt-2 mb-2" variant="primary" type="button" onClick={fetchVideoData}>
									Fetch
								</Button>

								{fetchIsLoading && (
									<div
										style={{
											width: 'max-content',
											height: 'max-content',
											marginTop: '16px'
										}}
									>
										<Spinner style={{ position: 'relative' }} />
									</div>
								)}
							</div>
							<Form.Group controlId="TrailerId">
								<Form.Label>Trailer Id</Form.Label>
								<Form.Control
									type="text"
									name="trailerId"
									placeholder="Enter trailer ID"
									value={trailerId}
									onChange={e => {
										setTrailerId(e.target.value);
										// handleChange(e);
									}}
								/>
							</Form.Group>
							<div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
								<Button className="mt-2 mb-2" variant="primary" type="button" onClick={fetchTrailerData}>
									Fetch
								</Button>

								{fetchTrailerLoading && (
									<div
										style={{
											width: 'max-content',
											height: 'max-content',
											marginTop: '16px'
										}}
									>
										<Spinner style={{ position: 'relative' }} />
									</div>
								)}
							</div>
							<Form.Group controlId="title">
								<Form.Label>Title</Form.Label>
								<Form.Control
									type="text"
									name="title"
									placeholder="Enter title"
									value={formData.title}
									onChange={handleChange}
								/>
							</Form.Group>
							<Form.Group controlId="videolink">
								<Form.Label>Video Link</Form.Label>
								<Form.Control
									type="text"
									name="videolink"
									placeholder="Enter Video Link"
									value={formData.videolink}
									onChange={handleChange}
								/>
							</Form.Group>
							<Form.Group controlId="videolink">
								<Form.Label>Trailer Link</Form.Label>
								<Form.Control
									type="text"
									name="trailerLink"
									placeholder="Enter Video Link"
									value={formData.trailerLink}
									onChange={handleChange}
								/>
							</Form.Group>
							<Form.Group controlId="thumnailLink">
								<Form.Label>Thumnail Link</Form.Label>
								<Form.Control
									type="text"
									name="thumnailLink"
									placeholder="Enter Thumnail Link"
									value={formData.thumnailLink}
									onChange={handleChange}
								/>
							</Form.Group>
							<Form.Group controlId="trailerThumnailLink">
								<Form.Label>Trailer Thumnail Link</Form.Label>
								<Form.Control
									type="text"
									name="trailerThumnailLink"
									placeholder="Enter Trailer Thumnail Link"
									value={formData.trailerThumnailLink}
									onChange={handleChange}
								/>
							</Form.Group>
							<Form.Group controlId="instructor">
								<Form.Label>Instructor</Form.Label>
								<Form.Control
									as="select"
									name="instructor"
									value={formData.instructor || ''}
									onChange={e => {
										const selectedInstructor = e.target.value;
										if (selectedInstructor === 'add_new') {
											setIsAddingNewInstructor(true); // Show new instructor input
											handleChange({
												target: { name: 'instructor', value: '' }
											});
										} else {
											setIsAddingNewInstructor(false); // Hide new instructor input if an existing one is selected
											handleChange(e);
										}
									}}
								>
									<option value="">Select Instructor</option>
									{presentInstrutors?.map(instructor => (
										<option key={instructor._id} value={instructor.name}>
											{instructor.name}
										</option>
									))}
									{/* <option value="add_new">Add New Instructor</option> */}
								</Form.Control>
							</Form.Group>
							{isAddingNewInstructor && (
								<Form.Group controlId="newInstructor">
									<Form.Label>New Instructor</Form.Label>
									<Form.Control
										type="text"
										name="instructor"
										placeholder="Enter new instructor name"
										value={formData.instructor || ''}
										onChange={handleChange}
									/>
								</Form.Group>
							)}
							<Form.Group controlId="description">
								<Form.Label>Description</Form.Label>
								<ReactQuill value={formData.description} onChange={value => dispatch(setField('description', value))} />
							</Form.Group>
							<Form.Group controlId="shortDescription">
								<Form.Label>Short Description</Form.Label>
								<Form.Control
									type="text"
									placeholder="Enter a short description"
									value={formData.shortDescription}
									name="shortDescription"
									onChange={handleChange}
								/>
							</Form.Group>
							<FormControl className="mt-1" fullWidth>
								<InputLabel id="video-level">Choose the Level</InputLabel>
								<Select
									labelId="video-level"
									id="videoLevel"
									name="videoLevel"
									multiple
									value={formData.videoLevel || []} // Ensure it's always an array
									onChange={handleVideoLevelChange}
									label="Choose the Level"
									renderValue={selected => selected.join(', ')} // Display selected values as comma-separated
								>
									<MenuItem value="" disabled>
										<em>Select The Level of the Video</em>
									</MenuItem>
									{['Beginner', 'Intermediate', 'Advanced'].map(level => (
										<MenuItem key={level} value={level}>
											<Checkbox checked={formData.videoLevel.includes(level)} />
											<ListItemText primary={level} />
										</MenuItem>
									))}
								</Select>
							</FormControl>
							;
							<Form.Group controlId="duration">
								<Form.Label>Duration</Form.Label>
								<Form.Control
									type="text"
									name="duration"
									placeholder="Enter Duration"
									value={formData.duration}
									onChange={handleChange}
								/>
							</Form.Group>
							<Form.Label>Tags</Form.Label>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<Autocomplete
									freeSolo
									options={backendTags.map(tag => tag.name)}
									inputValue={query}
									onInputChange={(event, newInputValue) => setQuery(newInputValue)}
									onChange={(e, option) => {
										handleTagAdd(option);
										setQuery('');
									}}
									renderInput={params => <TextField {...params} label="Add Tag" fullWidth />}
								/>
								<div
									style={{
										display: 'flex',
										flexWrap: 'wrap',
										marginRight: '5px'
									}}
								>
									{formData?.tags.map((tag, index) => (
										<div key={index} className="tag">
											{tag} <span onClick={() => handleTagRemove(tag)}>x</span>
										</div>
									))}
								</div>
							</div>
							<Form.Label>Keywords</Form.Label>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<TextField
									label="Add Keyword"
									value={keywordQuery}
									onChange={e => setKeywordQuery(e.target.value)}
									onKeyDown={e => {
										if (e.key === 'Enter' && keywordQuery.trim()) {
											handleKeyWordAdd(keywordQuery);
											setKeywordQuery('');
											e.preventDefault(); // Prevent form submission on Enter
										}
									}}
									fullWidth
								/>
								<div
									style={{
										display: 'flex',
										flexWrap: 'wrap',
										marginRight: '5px'
									}}
								>
									{formData?.keywords.map((keyword, index) => (
										<div key={index} className="tag">
											{keyword.name} <span onClick={() => handleKeywordRemove(keyword)}>x</span>
										</div>
									))}
								</div>
							</div>
							<Form.Label>Products</Form.Label>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<Autocomplete
									freeSolo
									options={backendProducts.map(product => product.title)}
									inputValue={productQuery}
									onInputChange={(event, newInputValue) => setProductQuery(newInputValue)}
									renderInput={params => (
										<TextField
											{...params}
											label="Add Product"
											fullWidth
											onKeyDown={e => {
												if (e.key === 'Enter' || e.key === 'tab') {
													handleProductAdd(e.target.value);
												}
											}}
										/>
									)}
								/>
								<div
									style={{
										display: 'flex',
										flexWrap: 'wrap',
										marginRight: '5px'
									}}
								>
									{formData.products.map((product, index) => (
										<div key={index} className="tag">
											{product}
											<span onClick={() => handleProductRemove(product)}>x</span>
										</div>
									))}
								</div>
							</div>
							<ReleaseSchedule
								releaseDate={formData?.releaseDate}
								onReleaseDateChange={handleDateChange}
								newYorkMidnight={newYorkMidnight}
							/>
							<Button className="mt-4" variant="primary" type="button" onClick={handleSubmit}>
								Save
							</Button>
							{loading ? <CircularProgress size={24} /> : null}
						</Form>
					</CardContent>
				</Card>
			)}
		</div>
	);
};

export default AddClassVideos;
